import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Icon, IconComponent, PrimengButtonDirective } from '@web/shared/ui';
import { TooltipModule } from 'primeng/tooltip';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { Route, RouterLinkPipe } from '@web/common';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-multimedia-view-switcher',
  imports: [
    ButtonModule,
    PrimengButtonDirective,
    IconComponent,
    TooltipModule,
    RouterLink,
    RouterLinkActive,
    RouterLinkPipe,
  ],
  templateUrl: './multimedia-view-switcher.component.html',
  styleUrl: './multimedia-view-switcher.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultimediaViewSwitcherComponent {
  protected readonly Icon = Icon;
  protected readonly Route = Route;
}
